// eslint-disable-next-line max-classes-per-file
import React, { useState, useRef } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
import ErrorBoundary from '../../helpers/errorBoundary';

function _arePudoEqual(pudoOpt1, pudoOpt2) {
  return pudoOpt1.value.code === pudoOpt2.value.code;
}

function _areSelectionsEqual(pudoOpt1, pudoOpt2) {
  if (!pudoOpt1 && !pudoOpt2) {
    return true;
  }

  if ((!pudoOpt1 && pudoOpt2) || (pudoOpt1 && !pudoOpt2)) {
    return false;
  }

  return _arePudoEqual(pudoOpt1, pudoOpt2);
}

// Hacky times: figuring out rough equality
function _areSubOptsEqual(opts1, opts2) {
  if (!opts1 && !opts2) {
    return true;
  }

  if ((!opts1 && opts2) || (opts1 && !opts2) || (opts1.length !== opts2.length)) {
    return false;
  }

  const len = opts1.length;

  if (!len) {
    return true;
  }

  if (!_arePudoEqual(opts1[0], opts2[0])) {
    return false;
  }

  if (len > 1 && !_arePudoEqual(opts1[len-1], opts2[len-1])) {
    return false;
  }

  return true;
}

// Default Coordinates to zoom in on center Israel
const DefaultCoordinates = {
  SE: { lat: 30.491335, lng: 35.1668 },
  SW: { lat: 31.20596, lng: 34.327436 },
  NE: { lat: 32.686719, lng: 35.422387 },
  NW: { lat: 32.683069, lng: 35.598794 }
};

const DefaultZoom = 12;

const Map = withScriptjs(withGoogleMap((props) => {
  const { selection, opts: { boundOpts, markerOpts }, onMarkerClick } = props;
  const [defaultCenter, setDefaultCenter] = useState();
  const [markers, setMarkers] = useState();
  const map = useRef();

  function recalculate() {
    const { google } = window;
    const { maps } = google || {};
    setDefaultCenter();
    setMarkers();

    if (!map.current || !maps || !markerOpts || !markerOpts.length) {
      return;
    }

    let center;
    switch (!!selection) {
      case true: {
        const {
          value: { address: { coordinates: { latitude, longitude } } }
        } = selection;

        center = { lat: latitude, lng: longitude };
        break;
      }
      default: {
        const bounds = boundOpts
          ? (
            boundOpts.reduce(
              (b, { value: { address: { coordinates: { latitude, longitude } } } }) => {
                b.extend(new maps.LatLng(latitude, longitude));
                return b;
              },
              new maps.LatLngBounds()
            )
          ) : new maps.LatLngBounds(DefaultCoordinates.SW, DefaultCoordinates.NE);

        map.current.fitBounds(bounds);
        const ct = bounds.getCenter();
        center = { lat: ct.lat(), lng: ct.lng() };
      }
    }

    setDefaultCenter(center);

    setMarkers(
      markerOpts.map(pudoOpt => {
        const { value: { code, address: { coordinates: { latitude, longitude } } } } = pudoOpt;

        return (
          <Marker
            key={code}
            position={{ lat: latitude, lng: longitude }}
            onClick={onMarkerClick.bind(null, pudoOpt)}
          />
        );
      })
    );
  }

  return (
    <GoogleMap
      defaultZoom={DefaultZoom}
      // zoom={DefaultZoom}
      center={defaultCenter}
      // defaultCenter={defaultCenter}
      ref={mp => {
        if (!mp || map.current) {
          return;
        }
        map.current = mp;
        recalculate();
      }}
      defaultOptions={{
        minZoom: 8,
        maxZoom: 17
      }}
    >
      {markers && (
        selection
          ? markers
          : (
            <MarkerClusterer
              averageCenter
              enableRetinaIcons
              gridSize={60}
            >
              {markers}
            </MarkerClusterer>
          )
      )}
    </GoogleMap>
  );
}));

export default class MapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {
    const { selection, opts: { boundOpts, markerOpts } } = this.props;
    const {
      selection: prevSelection, opts: { boundOpts: prevBoundOpts, markerOpts: prevMarkerOpts }
    } = prevProps;
    const { hideMap } = this.state;


    // Hacky times: force re-rendering the map so that new bounds and center are applied
    if (
      !hideMap && (
        !_areSelectionsEqual(selection, prevSelection)
        || !_areSubOptsEqual(boundOpts, prevBoundOpts)
        || !_areSubOptsEqual(markerOpts, prevMarkerOpts)
      )
    ) {
      this.setState({ hideMap: true });
    }
  }

  render() {
    const { googleMapURL, opts, selection, onMarkerClick, onError } = this.props;
    const { hideMap } = this.state;

    if (hideMap) {
      this.setState({ hideMap: false });
      return null;
    }

    return (
      <ErrorBoundary onError={onError}>
        <Map
          googleMapURL={googleMapURL}
          opts={opts}
          selection={selection}
          onMarkerClick={onMarkerClick}
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: '400px' }} />}
          mapElement={<div style={{ height: '100%' }} />}
        />
      </ErrorBoundary>
    );
  }
}
